import { Stack } from '@mui/material';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { Title } from './Title';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { transformObjectFieldsToStringArray } from 'Utils/transformObjectKeysToStringArray';
import { useCallback, useEffect, useState } from 'react';
import { useAppSelector, useDictionary } from 'Hooks';
import { DisabilityConfirmationsList } from './DisabilityApprovalsList';
import { NoDisabilityConfirmations } from './NoDisabilityApprovals';
import {
  IDisabilityConfirmation,
  getDisabilityConfirmations,
} from 'API/disabilityConfirmation';
import { searchMedicationHistory } from 'API';
import { useLoader } from 'Hooks/useLoader';

export const DisabilityConfirmations = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const [disabilityConfirmations, setDisabilityConfirmations] = useState<
    IDisabilityConfirmation[]
  >([]);
  const [isHasMedHistory, setIsHasMedHistory] = useState<boolean>(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabilityApprovals);
  const { loader, isLoading, setIsLoading } = useLoader();

  const initDisabilityConfirmations = useCallback(async () => {
    setIsLoading(true);
    const [confirmations, medicationHistory] = await Promise.all([
      getDisabilityConfirmations(),
      searchMedicationHistory(),
    ]);
    if (confirmations) setDisabilityConfirmations(confirmations);
    if (medicationHistory && medicationHistory.length > 0)
      setIsHasMedHistory(true);
    setIsLoading(false);
  }, [setIsLoading]);

  useEffect(() => {
    initDisabilityConfirmations();
  }, [initDisabilityConfirmations, imposterId]);

  return (
    <>
      <CustomMetaTitle title={dictionary.pageTitle} />
      <LinkReturnToMain />
      {isLoading ? (
        loader
      ) : (
        <>
          {disabilityConfirmations.length > 0 || isHasMedHistory ? (
            <Stack>
              <Title
                title={dictionary.title}
                texts={transformObjectFieldsToStringArray(dictionary.subTitle)}
              />
              <DisabilityConfirmationsList
                disabilityConfirmations={disabilityConfirmations}
                isHasMedHistory={isHasMedHistory}
              />
            </Stack>
          ) : (
            <NoDisabilityConfirmations />
          )}
        </>
      )}
    </>
  );
};
